const styles = {
  dateRangeWrapper: {
    '& .rdrDateDisplayItemActive input': {
      cursor: 'default !important'
    },
    '& .rdrDateInput input:hover': {
      cursor: 'default !important'
    },
    '& .rdrDateDisplayItemActive': {
      border: '1px solid transparent !important',
      outline: 'none !important'
    }
  }
};

export default styles;
